import { render, staticRenderFns } from "./Gather.vue?vue&type=template&id=90e35b42&scoped=true"
import script from "./Gather.vue?vue&type=script&lang=js"
export * from "./Gather.vue?vue&type=script&lang=js"
import style0 from "./Gather.vue?vue&type=style&index=0&id=90e35b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e35b42",
  null
  
)

export default component.exports